/**
 * Имена событий UI-телеметрии.
 *
 * Закрытый список, зеркалит серверный: сервер молча отбрасывает
 * неизвестные, поэтому опечатка в имени тихо теряет данные,
 * а не даёт ошибку.
 */

// Мастера приёмки: где водители бросают процесс
export const WIZARD_STEP_ENTERED = 'wizard.step_entered'
export const WIZARD_STEP_COMPLETED = 'wizard.step_completed'
export const WIZARD_ABANDONED = 'wizard.abandoned'

// Отказы и трение
export const PHOTO_RETAKE = 'photo.retake'
export const GEO_PERMISSION_DENIED = 'geo.permission_denied'
export const QUEUE_MANUAL_RETRY = 'queue.manual_retry'
export const FORM_VALIDATION_FAILED = 'form.validation_failed'

// Консоль: что используется, а что можно удалить
export const FILTER_APPLIED = 'filter.applied'
export const PRESET_CHANGED = 'preset.changed'
export const BULK_ACTION_USED = 'bulk_action.used'
export const EXPORT_CLICKED = 'export.clicked'
export const SEARCH_USED = 'search.used'

// Производительность глазами пользователя
export const PERF_FIRST_KPI = 'perf.first_kpi'
export const PERF_PHOTO_UPLOAD = 'perf.photo_upload'

export const UI_EVENTS = [
  WIZARD_STEP_ENTERED, WIZARD_STEP_COMPLETED, WIZARD_ABANDONED,
  PHOTO_RETAKE, GEO_PERMISSION_DENIED, QUEUE_MANUAL_RETRY,
  FORM_VALIDATION_FAILED,
  FILTER_APPLIED, PRESET_CHANGED, BULK_ACTION_USED, EXPORT_CLICKED,
  SEARCH_USED,
  PERF_FIRST_KPI, PERF_PHOTO_UPLOAD,
]
